import "./DealDocumentDetails.css";

import { ArrowFullLeftDarkIcon, UploadLightIcon } from "../../../../../assets";
import { Button, CursorDataGrid, Divider, ReadonlyText, SeedFooter, SeedNavigation } from "../../../../../widget";
import { DeleteDealDocumentVersionModal, UploadDealDocumentModal } from "../../components";
import { useDealDocumentDetails } from "./useDealDocumentDetails";

const DealDocumentDetails = (): JSX.Element => {
  const {
    dealName,
    canUploadDealDocument,
    isDealLoading,
    documentType,
    documentVariant,
    dealUuid,
    dealDocumentUuid,
    historyColumns,
    historyLoading,
    historyRefreshToken,
    setHistoryRefreshToken,
    showUploadDealDocumentModal,
    showDeleteDocumentVersionModal,
    isDeleteDocumentVersionLoading,
    onHistoryChange,
    openUploadDealDocumentModal,
    closeUploadDealDocumentModal,
    confirmDeleteDocumentVersion,
    cancelDeleteDocumentVersion,
    handleBackClick,
  } = useDealDocumentDetails();

  return (
    <div className="DealDocumentDetailsPage">
      <SeedNavigation activeElement="Portfolio" />
      <div className="DealDocumentDetailsContainer">
        <Button
          className="DealDocumentDetailsBack"
          text="Back"
          variant="secondary"
          icon={<ArrowFullLeftDarkIcon />}
          iconPosition="left"
          onClick={handleBackClick}
          hasNoPadding
          minWidth={false}
        />

        <div className="DealDocumentDetailsIntro">
          <h1 className="DealDocumentDetailsDealName">{dealName || (isDealLoading ? "Loading..." : "--")}</h1>
        </div>
        <div className="DealDocumentDetailsCard">
          <div className="DealDocumentDetailsHeader">
            <h2 className="DealDocumentDetailsTitle">Document details</h2>
            {canUploadDealDocument && (
              <Button
                text="Upload new version"
                variant="primary"
                size="small"
                corners="rounded"
                icon={<UploadLightIcon />}
                iconPosition="left"
                className="DealDocumentDetailsUpload"
                onClick={openUploadDealDocumentModal}
              />
            )}
          </div>
          <p className="body2Light">The document versions of this document type and variant are shown here.</p>
          <div className="DealDocumentDetailsMeta">
            <ReadonlyText label="Document type" value={documentType || "--"} />
            <ReadonlyText label="Document variant" value={documentVariant || "--"} />
          </div>

          <Divider type="horizontal" className="DealDocumentDetailsDivider" />

          <h3 className="DealDocumentDetailsHistoryTitle">Version history</h3>
          <div className="DealDocumentDetailsGrid">
            <CursorDataGrid
              key={historyRefreshToken ? "deal-doc-history-1" : "deal-doc-history-0"}
              columns={historyColumns}
              data={[]}
              clientSide={false}
              filterable
              showFilterToggle
              onChange={onHistoryChange}
              pageable
              showTotalCount={false}
              hasNoPadding
              hasBottomMargin={false}
              noDataMessage="No documents to display"
              dataIsLoading={historyLoading}
              variant="seed"
              pagination={{ pageSize: 10 }}
            />
          </div>
        </div>
        {dealUuid && (
          <UploadDealDocumentModal
            show={showUploadDealDocumentModal}
            closeModal={closeUploadDealDocumentModal}
            dealUuid={dealUuid}
            dealDocumentUuid={dealDocumentUuid}
            documentType={documentType || undefined}
            customVariant={documentVariant || undefined}
            refreshDocuments={historyRefreshToken}
            setRefreshDocuments={setHistoryRefreshToken}
          />
        )}
        <DeleteDealDocumentVersionModal
          show={showDeleteDocumentVersionModal}
          isLoading={isDeleteDocumentVersionLoading}
          onConfirm={confirmDeleteDocumentVersion}
          onCancel={cancelDeleteDocumentVersion}
        />
        <SeedFooter />
      </div>
    </div>
  );
};

export default DealDocumentDetails;
